import request from 'utils/request';
import { DictionaryDto, PagedView } from './dictionary';

export interface UserBase {
    first_name: string;
    last_name: string;
    middle_name: string;
    phone_number: string;
    idn?: string | undefined;
    email: string;
    username: string;
    region: DictionaryDto;
}

export interface UserDto {
    username: string;
    password: string | undefined;
    passwordConfirm: string | undefined;
    first_name: string;
    last_name: string;
    middle_name: string;
    phone_number: string;
    id: number | undefined;
    idn?: string | undefined;
    email: string;
    region: DictionaryDto;
    branch: DictionaryDto | null;
    roles: string[];
    enabled: boolean;
    status?: string;
    pus_username?: string;
    personnelNumber?: string;
    colvirId?: string;
}

export interface UserListDto extends Omit<UserDto, 'roles'> {
    roles: DictionaryDto[] | undefined;
}

export const initUser = (data: any = {}): UserDto => ({
    ...{
        id: undefined,
        email: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        password: '',
        phone_number: '',
        region: null,
        branch: null,
        roles: [],
        idn: '',
        username: '',
        passwordConfirm: '',
        enabled: true,
        pus_username: '',
        personnelNumber: '',
        colvirId: '',
    },
    ...data,
});

export function fetchCurrentUser(): Promise<UserDto> {
    return request('/users/current').then(({ data }) => data as UserDto);
}

export function deactivateUser(userId: number | undefined, status: string | undefined) {
    return request(`/users/${userId}/${status}`, {
        method: 'PUT',
    });
}

interface FreelanceCourierParam {
    page: number;
    size: number;
    value: string | null | undefined;
}

export function fetchFreelanceCouriers({
    page,
    size,
    value,
}: FreelanceCourierParam): Promise<PagedView<UserListDto>> {
    return request('/courier/freelancer-list', {
        params: {
            page,
            size,
            value,
        },
    }).then(({ data }) => data as PagedView<UserListDto>);
}
